module.exports = __webpack_public_path__ + "static/media/phone-plus.bc286bcd.svg";